<template>
  <div class="contact-footer">
    <section
      id="contact"
      class="contact-footer__section"
      data-aos="fade-up"
      data-aos-duration="1000"
    >
      <header class="contact-footer__header" data-aos="fade-up" data-aos-duration="800">
        <span class="contact-footer__eyebrow">Get In Touch</span>
        <h2 class="contact-footer__heading">We’re ready to support your wellness journey</h2>
        <p class="contact-footer__subheading">Share a few details and a BioEdge specialist will reach out within 24 hours.</p>
      </header>
      <div class="contact-footer__grid">
        <div class="contact-footer__info">
          <div class="contact-footer__info-list">
            <p class="contact-footer__info-item">
              <svg class="contact-footer__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"></path>
              </svg>
              <span>We Courier Nationwide</span>
            </p>
            <p class="contact-footer__info-item">
              <a
                href="https://wa.me/27716573969?text=Hi%2C%20I%20would%20like%20to%20ask%20about%20pricing!"
                target="_blank"
                rel="noopener noreferrer"
                class="contact-footer__link"
              >
                <svg
                  class="contact-footer__icon contact-footer__icon--whatsapp"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 308 308"
                >
                  <path
                    d="M227.904,176.981c-0.6-0.288-23.054-11.345-27.044-12.781c-1.629-0.585-3.374-1.156-5.23-1.156
                        c-3.032,0-5.579,1.511-7.563,4.479c-2.243,3.334-9.033,11.271-11.131,13.642c-0.274,0.313-0.648,0.687-0.872,0.687
                        c-0.201,0-3.676-1.431-4.728-1.888c-24.087-10.463-42.37-35.624-44.877-39.867c-0.358-0.61-0.373-0.887-0.376-0.887
                        c0.088-0.323,0.898-1.135,1.316-1.554c1.223-1.21,2.548-2.805,3.83-4.348c0.607-0.731,1.215-1.463,1.812-2.153
                        c1.86-2.164,2.688-3.844,3.648-5.79l0.503-1.011c2.344-4.657,0.342-8.587-0.305-9.856c-0.531-1.062-10.012-23.944-11.02-26.348
                        c-2.424-5.801-5.627-8.502-10.078-8.502c-0.413,0-1.732,0.073-2.109,0.089c-2.109,0.089-13.594,1.601-18.672,4.802
                        c-5.385,3.395-14.495,14.217-14.495,33.249c0,17.129,10.87,33.302,15.537,39.453c0.116,0.155,0.329,0.47,0.638,0.922
                        c17.873,26.102,40.154,45.446,62.741,54.469c21.745,8.686,32.042,9.69,37.896,9.69c2.46,0,4.429-0.193,6.166-0.364l1.102-0.105
                        c7.512-0.666,24.02-9.22,27.775-19.655c2.958-8.219,3.738-17.199,1.77-20.458C233.168,179.508,230.845,178.393,227.904,176.981z"
                  ></path>
                  <path
                    d="M156.734,0C73.318,0,5.454,67.354,5.454,150.143c0,26.777,7.166,52.988,20.741,75.928L0.212,302.716
                        c-0.484,1.429-0.124,3.009,0.933,4.085C1.908,307.58,2.943,308,4,308c0.405,0,0.813-0.061,1.211-0.188l79.92-25.396
                        c21.87,11.685,46.588,17.853,71.604,17.853C240.143,300.27,308,232.923,308,150.143C308,67.354,240.143,0,156.734,0z
                        M156.734,268.994c-23.539,0-46.338-6.797-65.936-19.657c-0.659-0.433-1.424-0.655-2.194-0.655c-0.407,0-0.815,0.062-1.212,0.188
                        l-40.035,12.726l12.924-38.129c0.418-1.234,0.209-2.595-0.561-3.647c-14.924-20.392-22.813-44.485-22.813-69.677
                        c0-65.543,53.754-118.867,119.826-118.867c66.064,0,119.812,53.324,119.812,118.867
                        C276.546,215.678,222.799,268.994,156.734,268.994z"
                  ></path>
                </svg>
                +27 71 657 3969
              </a>
            </p>
            <p class="contact-footer__info-item">
              <svg class="contact-footer__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
              </svg>
              <span>bioedge.sa@gmail.com</span>
            </p>
          </div>
        </div>
        <form @submit.prevent="sendContactEmail" class="contact-footer__form">
          <label class="contact-footer__label">
            <span class="contact-footer__label-text">Full Name</span>
            <input
              type="text"
              v-model="contactName"
              placeholder="Leroy Jenkins"
              class="contact-footer__input"
              required
            />
          </label>
          <label class="contact-footer__label">
            <span class="contact-footer__label-text">Email Address</span>
            <input
              type="email"
              v-model="contactEmail"
              placeholder="leroy@jenkins.com"
              class="contact-footer__input"
              required
            />
          </label>
          <label class="contact-footer__label">
            <span class="contact-footer__label-text">Message</span>
            <textarea
              rows="3"
              v-model="contactMessage"
              placeholder="Let us know what's on your mind!"
              class="contact-footer__textarea"
              required
            ></textarea>
          </label>
          <button
            type="submit"
            class="contact-footer__submit"
          >
            Submit
          </button>
        </form>
      </div>
    </section>

    <footer class="contact-footer__base" data-aos="fade-up" data-aos-duration="1000">
      <div class="contact-footer__base-shell contact-footer__base-shell--center">
        <p class="contact-footer__copyright">
          © Copyright {{ currentYear }} BioEdge. All Rights Reserved.
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import { RouterLink } from 'vue-router'

export default {
  name: 'ContactFooter',
  components: { RouterLink },
  data() {
    return {
      contactName: '',
      contactEmail: '',
      contactMessage: ''
    }
  },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  },
  methods: {
    sendContactEmail() {
      const baseURL = 'https://wa.me/27716573969'
      const message = `Hello, I would like to get in touch!

Name: ${this.contactName}
Email: ${this.contactEmail}
Message:
${this.contactMessage}`.trim()

      const encodedMessage = encodeURIComponent(message)
      this.openWhatsApp(`${baseURL}?text=${encodedMessage}`)

      this.contactName = ''
      this.contactEmail = ''
      this.contactMessage = ''
    },
    openWhatsApp(whatsappUrl) {
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

      try {
        if (isIOS && isSafari) {
          window.location.href = whatsappUrl
        } else if (isIOS) {
          const newWindow = window.open(whatsappUrl, '_blank')
          if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
            window.location.href = whatsappUrl
          }
        } else {
          const newWindow = window.open(whatsappUrl, '_blank')
          if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
            window.location.href = whatsappUrl
          }
        }
      } catch (error) {
        console.warn('WhatsApp redirect failed, using fallback:', error)
        window.location.href = whatsappUrl
      }
    }
  }
}
</script>

<style scoped>
.contact-footer__section {
  padding: clamp(3.5rem, 6vw, 5.5rem) 1.5rem clamp(4rem, 7vw, 6rem);
  background: #ffffff;
  color: #111827;
}

.contact-footer__header {
  text-align: center;
  margin-bottom: clamp(2.5rem, 6vw, 3.5rem);
  max-width: 42rem;
  margin-inline: auto;
}

.contact-footer__eyebrow {
  display: block;
  font-family: 'Montserrat', sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.35rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: rgba(17, 24, 39, 0.6);
}

.contact-footer__heading {
  margin-top: 1rem;
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  line-height: 1.2;
  font-size: clamp(1.8rem, 3vw, 2.6rem);
  color: #52cd36;
}

.contact-footer__subheading {
  margin-top: 1.25rem;
  font-size: 0.95rem;
  color: #4b5563;
  line-height: 1.7;
}

.contact-footer__grid {
  display: grid;
  gap: 2rem;
  max-width: 75rem;
  margin: 0 auto;
  grid-template-columns: repeat(auto-fit, minmax(18rem, 1fr));
  border-top: 1px solid rgba(17, 24, 39, 0.08);
  border-bottom: 1px solid rgba(17, 24, 39, 0.08);
  padding: 2.5rem 0;
}

.contact-footer__info {
  padding-right: clamp(0rem, 4vw, 2rem);
}

.contact-footer__info-list {
  display: flex;
  flex-direction: column;
  gap: 1.15rem;
  color: #111827;
  font-size: 1rem;
}

.contact-footer__info-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.contact-footer__icon {
  width: 1.25rem;
  height: 1.25rem;
  color: #52cd36;
  flex-shrink: 0;
}

.contact-footer__icon--whatsapp {
  width: 1.45rem;
  height: 1.45rem;
}

.contact-footer__link {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  color: inherit;
  text-decoration: underline;
  transition: color 0.2s ease;
}

.contact-footer__link:hover {
  color: #52cd36;
}

.contact-footer__form {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding: 0 0.5rem;
}

.contact-footer__label {
  display: block;
  text-align: left;
}

.contact-footer__label-text {
  display: block;
  font-weight: 600;
  margin-bottom: 0.4rem;
  color: #1f2937;
}

.contact-footer__input,
.contact-footer__textarea {
  width: 100%;
  border-radius: 9999px;
  border: 1px solid rgba(17, 24, 39, 0.08);
  background-color: rgba(255, 255, 255, 0.95);
  color: #111827;
  padding: 0.75rem 1.25rem;
  font-size: 1rem;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08);
  font-family: 'Montserrat', sans-serif;
}

.contact-footer__textarea {
  min-height: 140px;
  border-radius: 1.5rem;
  resize: vertical;
}

.contact-footer__input::placeholder,
.contact-footer__textarea::placeholder {
  color: rgba(107, 114, 128, 0.75);
}

.contact-footer__input:focus,
.contact-footer__textarea:focus {
  outline: none;
  border-color: rgba(82, 205, 54, 0.55);
  box-shadow: 0 0 0 4px rgba(82, 205, 54, 0.15);
}

.contact-footer__submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  border-radius: 9999px;
  padding: 0.75rem 2.25rem;
  border: 1px solid rgba(82, 205, 54, 0.6);
  color: #1f3016;
  font-weight: 600;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.96), rgba(244, 255, 240, 0.96));
  box-shadow: 0 18px 36px rgba(82, 205, 54, 0.22);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.contact-footer__submit:hover {
  transform: translateY(-2px);
  box-shadow: 0 24px 45px rgba(82, 205, 54, 0.28);
}

.contact-footer__base {
  background: #ffffff;
  padding: 2.5rem 1.5rem;
  border-top: 1px solid rgba(17, 24, 39, 0.08);
}

.contact-footer__base-shell {
  max-width: 72rem;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.contact-footer__base-shell--center {
  justify-content: center;
}

.contact-footer__copyright {
  font-size: 0.875rem;
  color: #4b5563;
}

@media (max-width: 768px) {
  .contact-footer__submit {
    width: 100%;
    justify-content: center;
  }

  .contact-footer__grid {
    padding-inline: 0;
  }

  .contact-footer__base-shell {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
}
</style>
